<onyx-information-heading>
  {{ 'labels.payment' | translate }}
</onyx-information-heading>

<onyx-information-list>
  <onyx-information-row label="labels.tradeCredit">
    <div class="limit">
      {{ 'labels.limit' | translate }}:

      @if (payment().parameters.tradeCreditLimit; as limit) {
        {{ limit | onyxAmount: undefined : false : 0 }}
      } @else {
        {{ 'labels.lack' | translate }}
      }
    </div>
  </onyx-information-row>

  <onyx-information-row label="labels.paymentTerm">
    <app-contractor-payment-term
      [payment]="payment()"
    ></app-contractor-payment-term>
  </onyx-information-row>

  <!--
  <onyx-information-row label="labels.timeliness">
  N/A
  </onyx-information-row>
  -->

  <onyx-information-row label="labels.cashDiscount">
    @let cashDiscounts = payment().parameters.cashDiscount;
    @if (cashDiscounts && cashDiscounts.length) {
      @for (cashDiscount of cashDiscounts; track $index) {
        {{ cashDiscount.percentage / 100 | number: '1.0-2' }}%
        {{ 'labels.inTerm' | translate | lowercase }}
        {{ cashDiscount.termDays }}
        {{ 'labels.days' | translate | lowercase }}{{ !$last ? ', ' : '' }}
      }
    } @else {
      {{ 'labels.no' | translate }}
    }
  </onyx-information-row>

  <onyx-information-row label="labels.factoringConsent">
    {{
      `labels.${payment().parameters.hasFactoringConsent ? 'yes' : 'no'}`
        | translate
    }}
  </onyx-information-row>
</onyx-information-list>
